import React, { useState, useEffect } from 'react';
import { notification } from '../../component/hocs/notification';
import Header from '../../component/layout/Header';
import Footer from '../../component/layout/Footer';
import Page from '../../component/utility/Page';
import DataTable from 'react-data-table-component';
import { custTableStyles } from '../../style/color';
import axios from 'axios';
import { mainurl } from '../../Mainurl';
import * as XLSX from 'xlsx/xlsx.mjs';

import {
    Row,
    Col,
    Card,
    CardHeader,
    CardBody,
    Form,
    Input,
    InputGroup,
    InputGroupText,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    Badge,
    Spinner,
    Alert
} from 'reactstrap';
import {
    FaEye,
    FaSearch,
    FaDownload,
    FaCalendarAlt,
    FaUsers,
    FaBox,
    FaWarehouse,
    FaTruck,
    FaWeight,
    FaClipboardList
} from 'react-icons/fa';

const Distribution = () => {
    const [mode, setMode] = useState("1");
    const [loading, setLoading] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [downloadLoading, setDownloadLoading] = useState(false);

    const [viewModal, setViewModal] = useState(false);
    const [modalData, setModalData] = useState([]);

    const get_distribution_list = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            let postData = [{
                "org_id": sessionStorage.getItem('org_id'),
                "user_id": sessionStorage.getItem('user_id'),
                "lang_id": 1
            }];

            const response = await axios({
                method: 'post',
                url: mainurl + 'Activity/input_distribution_view',
                data: postData,
                headers: { 'Content-Type': 'application/JSON' }
            });

            let list = response.data.map((row, index) => {
                return {
                    sl: index + 1,
                    location: row.wh_id,
                    date: row.distribution_date.split(" ")[0].split('-').reverse().join('-'),
                    product_name: row.prod_name,
                    total_qty: row.distribution_qty,
                    farmer_count: row.total_farmer,
                    action: (
                        <Button
                            color="info"
                            size="sm"
                            outline
                            className="d-flex align-items-center gap-1"
                            onClick={() => farmer_list_handler(row.farmer_detail)}
                        >
                            <FaEye size={14} />
                            View
                        </Button>
                    ),
                    rawData: row
                };
            });

            setTableData(list);
            setFilteredData(list);

            let notify = notification({
                message: `${list.length} distribution records loaded successfully`,
                type: 'success'
            });
            notify();
        } catch (error) {
            let notify = notification({
                message: "Failed to load distribution records. Please try again.",
                type: 'error'
            });
            notify();
        } finally {
            setLoading(false);
        }
    };

    const farmer_list_handler = (dtl) => {
        const list = dtl.map((row, index) => {
            return {
                sl: index + 1,
                farmer_code: row.farmer_code,
                farmer_name: row.f_name + " (" + row.f_name_ne + ")",
                qty: row.distribution_qty + " " + row.uom_desc
            };
        });

        setModalData(list);
        setViewModal(true);
    };

    const download_excel_handler = async () => {
        setDownloadLoading(true);

        try {
            let postData = [{
                "org_id": sessionStorage.getItem('org_id')
            }];

            const response = await axios({
                method: 'post',
                url: mainurl + 'Traceability/farmer_input_distribution_ex',
                data: postData,
                headers: { 'Content-Type': 'application/JSON' }
            });

            let list = response.data.map((row, index) => {
                return {
                    sl_no: index + 1,
                    farmer_code: row.farmer_code,
                    farmer_name: row.f_name,
                    distribution_date: row.distribution_date?.split(" ")[0].split('-').reverse().join('-'),
                    quantity: row["concat(a.distribution_qty,' ', u.uom_desc)"],
                };
            });

            if (list.length > 0) {
                let wb = XLSX.utils.book_new(),
                    ws = XLSX.utils.json_to_sheet(list);
                XLSX.utils.book_append_sheet(wb, ws, "Distribution_Report");
                XLSX.writeFile(wb, `distribution_report_${new Date().toISOString().split('T')[0]}.xlsx`);

                let notify = notification({
                    message: "Excel report downloaded successfully!",
                    type: 'success'
                });
                notify();
            } else {
                let notify = notification({
                    message: "No data available for download",
                    type: 'warning'
                });
                notify();
            }
        } catch (error) {
            let notify = notification({
                message: "Download failed. Please try again.",
                type: 'error'
            });
            notify();
        } finally {
            setDownloadLoading(false);
        }
    };

    // Search functionality
    const handleSearch = (value) => {
        setSearchTerm(value);
        if (value === '') {
            setFilteredData(tableData);
        } else {
            const filtered = tableData.filter(item =>
                item.product_name.toLowerCase().includes(value.toLowerCase()) ||
                item.location.toLowerCase().includes(value.toLowerCase()) ||
                item.date.includes(value) ||
                item.total_qty.toString().includes(value)
            );
            setFilteredData(filtered);
        }
    };

    const columns = [
        {
            name: '#',
            selector: row => row.sl,
            sortable: true,
            width: '70px',
            center: true
        },
        {
            name: (
                <div className="d-flex align-items-center gap-1">
                    <FaCalendarAlt size={12} />
                    Distribution Date
                </div>
            ),
            selector: row => row.date,
            sortable: true,
            width: '150px'
        },
        {
            name: (
                <div className="d-flex align-items-center gap-1">
                    <FaWarehouse size={12} />
                    Location
                </div>
            ),
            selector: row => row.location,
            sortable: true,
            cell: row => (
                <div className="text-truncate" title={row.location}>
                    {row.location != 0 ? row.location : 'N/A'}
                </div>
            )
        },
        {
            name: (
                <div className="d-flex align-items-center gap-1">
                    <FaBox size={12} />
                    Product Name
                </div>
            ),
            selector: row => row.product_name,
            sortable: true,
            width: "25%",
        },
        {
            name: (
                <div className="d-flex align-items-center gap-1">
                    <FaWeight size={12} />
                    Total Quantity
                </div>
            ),
            selector: row => row.total_qty,
            sortable: true,
            center: true,
            cell: row => (
                <Badge color="info" pill>
                    {row.total_qty}
                </Badge>
            )
        },
        {
            name: (
                <div className="d-flex align-items-center gap-1">
                    <FaUsers size={12} />
                    Recipients
                </div>
            ),
            selector: row => row.farmer_count,
            sortable: true,
            center: true,
            cell: row => (
                <Badge color={row.farmer_count > 20 ? 'success' : row.farmer_count > 10 ? 'warning' : 'danger'} pill>
                    {row.farmer_count}
                </Badge>
            )
        },
        {
            name: 'Actions',
            selector: row => row.action,
            sortable: false,
            center: true,
            width: '120px'
        }
    ];

    return (
        <>
            <Header />
            <Page title='Input Distribution Management' breadcrumbs='Home / Input Distribution'>
                <Row className='p-3'>
                    {mode === "1" && (
                        <Col xs={12}>
                            {/* Action Bar */}
                            <Card className='mb-4 border-0 shadow-sm'>
                                <CardBody className="py-3">
                                    <Row className="align-items-center">
                                        <Col md={8}>
                                            <div className="d-flex gap-2">
                                                <Button
                                                    color='primary'
                                                    size="sm"
                                                    onClick={get_distribution_list}
                                                    disabled={loading}
                                                    className="d-flex align-items-center gap-2"
                                                >
                                                    {loading ? (
                                                        <Spinner size="sm" />
                                                    ) : (
                                                        <FaSearch size={14} />
                                                    )}
                                                    {loading ? 'Loading...' : 'Load Distribution Records'}
                                                </Button>
                                                <Button
                                                    color='secondary'
                                                    size="sm"
                                                    onClick={download_excel_handler}
                                                    disabled={downloadLoading || tableData.length === 0}
                                                    className="d-flex align-items-center gap-2 text-white"
                                                >
                                                    {downloadLoading ? (
                                                        <Spinner size="sm" />
                                                    ) : (
                                                        <FaDownload size={14} />
                                                    )}
                                                    {downloadLoading ? 'Downloading...' : 'Download Excel'}
                                                </Button>
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <InputGroup size="sm">
                                                <InputGroupText className="bg-light border-end-0">
                                                    <FaSearch className="text-muted" />
                                                </InputGroupText>
                                                <Input
                                                    type="search"
                                                    placeholder='Search products, locations, dates...'
                                                    value={searchTerm}
                                                    onChange={(e) => handleSearch(e.target.value)}
                                                    className="border-start-0"
                                                />
                                            </InputGroup>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>

                            {/* Statistics Cards */}
                            {tableData.length > 0 && (
                                <Row className="mb-4">
                                    <Col md={3}>
                                        <Card className="border-0 bg-primary text-white">
                                            <CardBody className="text-center py-3">
                                                <FaTruck size={24} className="mb-2" />
                                                <h5 className="mb-0">{tableData.length}</h5>
                                                <small>Total Distributions</small>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col md={3}>
                                        <Card className="border-0 bg-success text-white">
                                            <CardBody className="text-center py-3">
                                                <FaUsers size={24} className="mb-2" />
                                                <h5 className="mb-0">
                                                    {tableData.reduce((sum, item) => sum + parseInt(item.farmer_count), 0)}
                                                </h5>
                                                <small>Total Recipients</small>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col md={3}>
                                        <Card className="border-0 bg-info text-white">
                                            <CardBody className="text-center py-3">
                                                <FaBox size={24} className="mb-2" />
                                                <h5 className="mb-0">
                                                    {new Set(tableData.map(item => item.product_name)).size}
                                                </h5>
                                                <small>Unique Products</small>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col md={3}>
                                        <Card className="border-0 bg-warning text-white">
                                            <CardBody className="text-center py-3">
                                                <FaWeight size={24} className="mb-2" />
                                                <h5 className="mb-0">
                                                    {tableData.reduce((sum, item) => sum + parseFloat(item.total_qty), 0).toFixed(2)}
                                                </h5>
                                                <small>Total Quantity</small>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                            )}

                            {/* Main Data Table */}
                            <Card className='border-0 shadow-sm'>
                                <CardHeader className="bg-white border-bottom">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div>
                                            <h5 className="mb-0">Distribution Records</h5>
                                            <small className='text-muted'>
                                                {filteredData.length > 0 ?
                                                    `Showing ${filteredData.length} of ${tableData.length} distribution records` :
                                                    'No distribution records found'
                                                }
                                            </small>
                                        </div>
                                        {searchTerm && (
                                            <Badge color="secondary" className="ms-2">
                                                Filtered: {filteredData.length}
                                            </Badge>
                                        )}
                                    </div>
                                </CardHeader>
                                <CardBody className="p-0">
                                    {tableData.length === 0 && !loading ? (
                                        <Alert color="info" className="m-3 text-center">
                                            <FaTruck size={48} className="mb-3 text-muted" />
                                            <p className="mb-2">No distribution records loaded yet</p>
                                            <small>Click "Load Distribution Records" to fetch the latest distribution data</small>
                                        </Alert>
                                    ) : (
                                        <DataTable
                                            title=""
                                            customStyles={custTableStyles}
                                            columns={columns}
                                            data={filteredData}
                                            highlightOnHover
                                            responsive
                                            pagination
                                            paginationPerPage={10}
                                            paginationRowsPerPageOptions={[10, 25, 50, 100]}
                                            progressPending={loading}
                                            progressComponent={
                                                <div className="d-flex flex-column align-items-center justify-content-center py-5">
                                                    <Spinner color="primary" />
                                                    <p className="mt-2 text-muted">Loading distribution records...</p>
                                                </div>
                                            }
                                            noDataComponent={
                                                <div className="text-center py-5">
                                                    <FaSearch size={48} className="text-muted mb-3" />
                                                    <p className="text-muted">No distribution records match your search criteria</p>
                                                </div>
                                            }
                                        />
                                    )}
                                </CardBody>
                            </Card>
                        </Col>
                    )}
                </Row>
            </Page>

            {/* Enhanced Modal */}
            <Modal
                centered
                scrollable
                size="lg"
                isOpen={viewModal}
                toggle={() => setViewModal(!viewModal)}
                className="modal-dialog-scrollable"
            >
                <ModalHeader
                    toggle={() => setViewModal(!viewModal)}
                    className="bg-light border-bottom"
                >
                    <div className="d-flex align-items-center gap-2">
                        <FaUsers className="text-primary" />
                        <div>
                            <h5 className="mb-0">Distribution Recipients</h5>
                            <small className="text-muted">
                                {modalData.length} farmer{modalData.length !== 1 ? 's' : ''} received inputs
                            </small>
                        </div>
                    </div>
                </ModalHeader>
                <ModalBody className="p-0">
                    <DataTable
                        title=""
                        customStyles={custTableStyles}
                        columns={[
                            {
                                name: '#',
                                selector: row => row.sl,
                                sortable: true,
                                width: '80px',
                                center: true
                            },
                            {
                                name: 'Farmer Code',
                                selector: row => row.farmer_code,
                                sortable: true,
                                cell: row => (
                                    <Badge className="text-primary"
                                        color="light"
                                        pill>
                                        {row.farmer_code}
                                    </Badge>
                                )
                            },
                            {
                                name: 'Farmer Name',
                                selector: row => row.farmer_name,
                                sortable: true,
                                width: "45%",
                            },
                            {
                                name: (
                                    <div className="d-flex align-items-center gap-1">
                                        <FaWeight size={12} />
                                        Quantity
                                    </div>
                                ),
                                selector: row => row.qty,
                                sortable: true,
                                cell: row => (
                                    <Badge color="info" pill>
                                        {row.qty}
                                    </Badge>
                                )
                            }
                        ]}
                        data={modalData}
                        highlightOnHover
                        pagination
                        paginationPerPage={15}
                        dense
                        responsive
                    />
                </ModalBody>
            </Modal>

            <Footer />
        </>
    );
};

export default Distribution;